import wpyColors from '../../wpyColors'
import { type GlobalSiteThemeType } from '../types/GlobalSiteThemeType'

const wastePayTheme: GlobalSiteThemeType = {
  addEntityButton: {
    classes: 'text-wpy-blue-700 hover:bg-wpy-blue-100 hover:text-wpy-blue-600 active:text-wpy-blue-500 border border-wpy-blue-700',
    iconClasses: '#0250C5'
  },
  basicBorder: {
    classes: 'border border-wpy-blue-700'
  },
  breadcrumbs: {
    classes: 'text-wpy-blue-700 hover:text-wpy-blue-600 active:text-wpy-blue-500',
    endText: 'text-gray-800'
  },
  buttonColors: {
    classes: 'bg-wpy-blue-700 hover:bg-wpy-blue-600 active:bg-wpy-blue-500 disabled:bg-wpy-blue-300',
    invertedClasses: 'rounded-md text-white p-2 disabled:bg-wpy-light-gray-200 bg-wpy-blue-700 hover:bg-wpy-blue-600 active:bg-wpy-medium-gray-300',
    secondaryClasses: 'text-wpy-blue-700 hover:bg-wpy-blue-100 active:bg-wpy-blue-200 border-wpy-blue-700'
  },
  checkboxColors: {
    classes: 'text-white accent-bg-wpy-blue-600 checked:bg-wpy-blue-600'
  },
  customerNavTabs: {
    activeClasses: 'text-wpy-blue-700 border-wpy-blue-700',
    inactiveClasses: 'border-transparent  text-gray-500  hover:text-gray-700 hover:border-gray-300'
  },
  datepickerFilterColors: {
    applyButtonClasses: 'text-wpy-blue-700 hover:bg-wpy-blue-100 active:bg-wpy-blue-200',
    buttonBackgroundClasses: ' bg-wpy-blue-700',
    clearButtonClasses: 'hover:text-wpy-blue-100 active:text-wpy-blue-200',
    selectedColorClasses: 'dodgerBlue'
  },
  deleteButtonColors: {
    classes: 'text-red-500 hover:bg-std-light-gray-100 active:bg-std-light-gray-300'
  },
  globalLoaderColors: {
    backgroundClasses: 'bg-wpy-blue-600',
    borderClasses: 'border-wpy-blue-600'
  },
  horizontalLine: {
    primaryClasses: 'border-wpy-blue-600',
    secondaryClasses: 'border-gray-400'
  },
  iconButton: {
    classes: 'disabled:bg-std-light-gray-200 flex disabled:border-std-light-gray-300 items-center justify-center py-2 px-4 rounded shadow text-white bg-wpy-blue-700  hover:bg-wpy-blue-500  border border-wpy-blue-700',
    iconClasses: '#FFF'
  },
  loginBackground: '#033A8D',
  mainBodyColor: wpyColors['super-light-gray']['400'],
  navigationLinkColors: {
    classes: 'text-wpy-blue-700 hover:bg-wpy-blue-100 active:bg-wpy-blue-200'
  },
  sideNavBar: {
    classes: 'bg-wpy-navy-700 '
  },
  sideNavBarButton: {
    activeClasses: 'bg-wpy-navy-active',
    classes: 'hover:bg-wpy-navy-600 active:bg-wpy-navy-400'
  },
  tableFooterColors: {
    classes: 'text-wpy-navy-600 hover:text-wpy-navy-400 '
  },
  tableHeaderColors: {
    backgroundClasses: 'bg-wpy-light-blue-700',
    fontClasses: 'font-lighter text-wpy-gray',
    secondaryFontClasses: 'text-black'
  },
  tableMainColors: {
    classes: 'border-t-white'
  },
  toggleButtonColors: {
    activeClasses: 'bg-wpy-blue-600',
    focusClasses: 'focus:outline-none focus:ring-2 focus:ring-wpy-blue-600 focus:ring-offset-2',
    inactiveClasses: ' bg-wpy-medium-gray-100'
  },
  toggleTabButtonColors: {
    activeClasses: 'bg-wpy-blue-700 text-white',
    commonClasses: 'rounded py-1 px-2 mr-1 cursor-pointer',
    inactiveClasses: 'text-wpy-blue-700'
  },
  topNavBarAccountButtonColors: {
    classes: 'text-blue-500 transition duration-150 ease-in-out bg-blue-100 hover:text-blue-400 focus:border-blue-300 focus:shadow-outline-blue active:bg-blue-50 active:text-blue-800 '
  },
  topNavBarColors: {
    classes: 'bg-white '
  },
  topNavBarHamburgerButton: {
    classes: 'bg-wpy-medium-gray-700'
  },
  topNavBarInputColors: {
    classes: 'bg-wpy-light-gray-100 border-wpy-medium-gray-300'
  },
  topNavBarMerchantSelector: {
    classes: 'border-gray-300 text-gray-500 focus:border-gray-700 focus:shadow-outline-gray active:bg-gray-50 active:text-gray-800'
  }
}
export default wastePayTheme
